module.exports = __webpack_public_path__ + "static/media/ku.fafdac37.png";